function createFetchHtmlPlugin() {
  Alpine.directive(
    "fetch-html",
    (el, { expression }, { evaluateLater, effect, cleanup }) => {
      const evaluateUrl = evaluateLater(expression);
      let controller = null;

      effect(() => {
        evaluateUrl((url) => {
          if (!url) return;
          if (el.getAttribute("data-loaded") === url) return;

          controller?.abort();
          controller = new AbortController();

          el.dispatchEvent(new CustomEvent("fetch-start", { detail: { url } }));
          el.setAttribute("data-loading", "true");

          fetch(url, { signal: controller.signal })
            .then(async (res) => {
              if (!res.ok) throw new Error(`HTTP ${res.status}`);
              return await res.text();
            })
            .then((html) => {
              el.innerHTML = html;
              el.setAttribute("data-loaded", url);
              el.dispatchEvent(
                new CustomEvent("fetch-success", { detail: { url } }),
              );
            })
            .catch((err) => {
              if (err.name === "AbortError") return;

              console.error("Ошибка Alpine fetch-html:", err);
              const errorMsg =
                el.getAttribute("data-error-msg") ||
                "Не удалось загрузить контент.";
              el.innerHTML = `<p class="p-6 text-red-500">${errorMsg}</p>`;
              el.dispatchEvent(
                new CustomEvent("fetch-error", { detail: { url, error: err } }),
              );
            })
            .finally(() => {
              el.removeAttribute("data-loading");
            });
        });
      });
      cleanup(() => controller?.abort());
    },
  );
}

export { createFetchHtmlPlugin };
